import { mediaQueryDown } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

interface PaneResizerProps {
  $overlapSide?: 'both' | 'after'
}

const PaneResizer = styled.div<PaneResizerProps>`
  width: ${rem(20)};
  margin-inline: ${(props) => props.$overlapSide === 'after' ? `0 ${rem(-20)}` : rem(-10)};
  cursor: col-resize;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: transparent;
  user-select: none;
  touch-action: none;
  z-index: ${zIndex.draggingItem};

  &::before {
    content: '';
    position: absolute;
    inset-block: 0;
    left: ${(props) => props.$overlapSide === 'after' ? 0 : '50%'};
    width: 1px;
    transform: translateX(-50%);
    background: ${(props) => props.theme.palette.neutral.surface.lightBackground};
    opacity: 0.7;
    transition: opacity 0.2s ease;
  }

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: ${(props) => props.$overlapSide === 'after' ? 0 : '50%'};
    box-sizing: border-box;
    width: ${rem(6)};
    height: ${rem(72)};
    border-radius: 0 ${rem(999)} ${rem(999)} 0;
    background: ${(props) => props.theme.palette.neutral.surface.normalBackground};
    border-top: 1px solid ${(props) => props.theme.palette.neutral.surface.lightForegroundAlt};
    border-right: 1px solid ${(props) => props.theme.palette.neutral.surface.lightForegroundAlt};
    border-bottom: 1px solid ${(props) => props.theme.palette.neutral.surface.lightForegroundAlt};
    box-shadow: 0 ${rem(2)} ${rem(8)} rgba(0, 0, 0, 0.12);
    opacity: 0.96;
    transform: translateY(-50%);
    transform-origin: left center;
    transition: transform 0.2s ease, opacity 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  }

  &:hover::before,
  &:active::before {
    opacity: 1;
  }

  &:hover::after,
  &:active::after {
    transform: translateY(-50%) scaleX(1.15);
    opacity: 1;
    background: ${(props) => props.theme.palette.neutral.surface.normalBackground};
    border-color: ${(props) => props.theme.palette.neutral.surface.lightForegroundAlt};
    box-shadow: 0 ${rem(3)} ${rem(10)} rgba(0, 0, 0, 0.16);
  }

  ${mediaQueryDown.tablet} {
    display: none;
  }
`

export default PaneResizer
